// Opt-in sound cues. Respects system mute. Short synthesized tone on result arrival.
// Uses Web Audio API — no external assets required.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!ctx) ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
  return ctx;
}

export function playSoundEnabled(): boolean {
  return localStorage.getItem('pv-sound') === '1';
}

export function toggleSound(): boolean {
  const enabled = !playSoundEnabled();
  localStorage.setItem('pv-sound', enabled ? '1' : '0');
  return enabled;
}

export async function playResultTone(isYes: boolean): Promise<void> {
  if (!playSoundEnabled()) return;
  try {
    const audioCtx = getCtx();
    if (audioCtx.state === 'suspended') await audioCtx.resume();

    const now = audioCtx.currentTime;
    const gain = audioCtx.createGain();
    gain.connect(audioCtx.destination);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.08, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);

    // Two-note chord — major (yes) or minor (no)
    const freqs = isYes ? [523.25, 659.25] : [493.88, 587.33]; // C5+E5 or B4+D5
    freqs.forEach(freq => {
      const osc = audioCtx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now);
      osc.connect(gain);
      osc.start(now);
      osc.stop(now + 0.4);
    });
  } catch {
    // Web Audio not supported or blocked — fail silently
  }
}
